"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userV1Api = exports.updateMe = void 0;
const createApi_1 = require("../../helpers/createApi");
const getMe = (caller) => () => caller('/users/me').get();
const updateMe = (caller) => (payload) => {
    return caller(`/users/me`).patch(payload);
};
exports.updateMe = updateMe;
const checkIsSignedIn = (caller) => async () => {
    try {
        await caller('/users/me').get(undefined, { bypassErrorHandlers: true });
    }
    catch (e) {
        return false;
    }
    return true;
};
exports.userV1Api = (0, createApi_1.createAPIFactory)({
    getMe,
    updateMe: exports.updateMe,
    checkIsSignedIn,
});
//# sourceMappingURL=api.js.map